import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";
import { useI18n } from "@/contexts/I18nContext";
import { useAuth } from "@/contexts/AuthContext";
import { Boxes, ShoppingBag, Users, ArrowRight } from "lucide-react";

export default function CasaMadreDashboard() {
  const { t } = useI18n();
  const { user } = useAuth();
  const [stats, setStats] = useState({ products: 0, tenants: 0, orders: 0 });
  const [network, setNetwork] = useState(null);

  useEffect(() => {
    Promise.all([
      api.get("/products"),
      api.get("/tenants"),
      api.get("/orders"),
      api.get(`/networks/${user.network_id}`),
    ]).then(([p, t, o, n]) => {
      setStats({ products: p.data.length, tenants: t.data.length, orders: o.data.length });
      setNetwork(n.data);
    });
  }, [user.network_id]);

  const term = network?.vertical_config?.terminology || {};

  return (
    <AdminLayout>
      <div className="p-8 lg:p-10" data-testid="cm-dashboard">
        <div className="mb-10">
          <div className="overline text-brand mb-2">{term.casa_madre_label || "Casa Madre"} · {network?.display_name}</div>
          <h1 className="font-heading font-bold text-4xl tracking-tight">{t("cm_dashboard")}</h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border border border-border rounded-sm overflow-hidden mb-10">
          <div className="bg-white p-6" data-testid="cm-stat-products">
            <Boxes className="w-5 h-5 text-brand mb-3" strokeWidth={1.5} />
            <div className="text-4xl font-heading font-bold leading-none">{stats.products}</div>
            <div className="text-xs text-muted-foreground mt-2">{term.prodotto_label || "Prodotti"} master</div>
          </div>
          <div className="bg-white p-6" data-testid="cm-stat-tenants">
            <Users className="w-5 h-5 text-brand mb-3" strokeWidth={1.5} />
            <div className="text-4xl font-heading font-bold leading-none">{stats.tenants}</div>
            <div className="text-xs text-muted-foreground mt-2">{term.rivenditori_label_plural || "Rivenditori"}</div>
          </div>
          <div className="bg-white p-6" data-testid="cm-stat-orders">
            <ShoppingBag className="w-5 h-5 text-brand mb-3" strokeWidth={1.5} />
            <div className="text-4xl font-heading font-bold leading-none">{stats.orders}</div>
            <div className="text-xs text-muted-foreground mt-2">Ordini B2B</div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <Link to="/casa-madre/products" data-testid="cm-link-products" className="admin-card p-6 group">
            <div className="overline text-brand mb-2">Modulo</div>
            <h3 className="font-heading font-bold text-2xl mb-2">{t("cm_products")}</h3>
            <p className="text-sm text-muted-foreground mb-4">Gestisci il catalogo master, varianti, stock e immagini.</p>
            <span className="text-brand text-sm inline-flex items-center gap-1.5 group-hover:gap-2.5 transition-all">Apri <ArrowRight className="w-4 h-4" /></span>
          </Link>
          <Link to="/casa-madre/orders" data-testid="cm-link-orders" className="admin-card p-6 group">
            <div className="overline text-brand mb-2">Modulo</div>
            <h3 className="font-heading font-bold text-2xl mb-2">{t("cm_orders")}</h3>
            <p className="text-sm text-muted-foreground mb-4">Ordini B2B generati dai rivenditori della tua rete.</p>
            <span className="text-brand text-sm inline-flex items-center gap-1.5 group-hover:gap-2.5 transition-all">Apri <ArrowRight className="w-4 h-4" /></span>
          </Link>
        </div>
      </div>
    </AdminLayout>
  );
}
